export default __webpack_public_path__ + "static/Mint_sky-b7b76e3ff57fad898cd7ef30fb29ec6b.png";